// for example: https://www.acc.edu.au/burnie/kindergarten
import React from 'react';
import styled from "styled-components";
import {BackgroundImage} from "@acc-monorepo/gatsby-stories/v2/styles/shared";


const Wrapper = styled.section`
  display: block;
  position: relative;
  padding: 13vh 0;
  height: 50vh;
  width: 100%;
  overflow: hidden;
  margin-bottom: 2rem;
  background-color: #000;
  
  @media(min-width: 768px) {
    height: 33vh;
    min-height: 36rem;
  }
`

const Content = styled.div`
  z-index: 2;
  position: absolute;
  bottom: 2rem;
  left: 1rem;
  width: calc(100% - 1rem);

  h1, .h1 {
    position: relative;
    color: #fff;
    font-size: 3rem;
    line-height: 1;
    font-weight: 700;
    z-index: 200;
    max-width: calc(var(--content-width-max) - 2rem);
    margin: auto;
    text-align: left;
  }

  p{
    color: #fff;
    z-index: 200;
  }

  @media(min-width: 768px){
    bottom: 2rem;
    left: 1rem;
    width: calc(100% - 2rem);

    h1, .h1 {
      font-size: 5rem;
    }
  }
`

export const Background = styled(BackgroundImage)`
  ::after {
    content: "";
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(to top, rgba(0,0,0, ${props => props.darkness ? props.darkness : 0.6 }) 0%, rgba(0,0,0,0) 66%);
  }
`

const HeadingWithBackground = ({ backgroundImage, backgroundAlt, darkness, className, children, objectPosition, contentCss, ...props}) => {
  return (
    <Wrapper className={className} {...props}>
      <Background
        image={backgroundImage}
        alt={backgroundAlt || "background image"}
        objectPosition={objectPosition}
        darkness={darkness}
        loading="eager"
      />
      <Content css={contentCss}>
        {children}
      </Content>
    </Wrapper>
  )
}

export default HeadingWithBackground
